module.exports = __webpack_public_path__ + "static/media/2021-arsredovisning-brf-lyfta.1013b250.pdf";